module.exports = __webpack_public_path__ + "img/soc_rutube.6761eb70.png";